// src/components/AdminDashboard.js
import React, { useEffect, useState } from "react";
import { Line } from "react-chartjs-2";
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from "chart.js";

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

function AdminDashboard({ user }) {
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!user?.isAdmin) return;

    fetch("/api/analytics/stats", { credentials: "include" })
      .then(res => res.json())
      .then(setData)
      .catch(err => console.error("Error loading analytics:", err));
  }, [user]);

  if (!user?.isAdmin) {
    return (
      <div className="text-center mt-10 text-gray-500">
        <p>Unauthorized – admin access only.</p>
      </div>
    );
  }

  if (!data) {
    return (
      <div className="text-center mt-10 text-gray-500">
        <p>Loading analytics...</p>
      </div>
    );
  }

  const chartData = {
    labels: data.map((d) => d.day),
    datasets: [
      {
        label: "Daily Visitors (Last 60 Days)",
        data: data.map((d) => d.visits),
        borderColor: "#2563EB",
        backgroundColor: "rgba(37,99,235,0.2)",
        fill: true,
        tension: 0.3,
      },
    ],
  };

  return (
    <div className="max-w-4xl mx-auto mt-10 bg-white rounded-lg shadow-md p-6">
      <h2 className="text-2xl font-bold text-gray-800 mb-6">
        Site Analytics Dashboard
      </h2>
      <Line
        data={chartData}
        options={{
          responsive: true,
          plugins: {
            legend: { position: "top" },
            title: { display: true, text: "Visitor Activity" },
          },
        }}
      />
    </div>
  );
}

export default AdminDashboard;
